import client from "../modules/client";

export const editUser = async (userID,params) => {
  return client(`/api/v0/users/${userID}`, { method: 'PUT', body: params }).then(({ data }) => data);
};

export const changeEmail = async (userID,email) => {
  return client(`/api/v0/users/${userID}/email`, { method: 'PUT', body: {email: email} }).then(({ data }) => data);
};

export const getUser = (userID) => {
  return client(`/api/v0/users/${userID}`).then(({ data }) => data?.profile);
};

export function useUserService () {
  return {
    editUser,
    getUser,
  };
}
